/* eslint-disable react-hooks/exhaustive-deps */
import '@aws-amplify/ui-react/styles.css';
import React, { useCallback, useEffect } from "react";

import {
  Alert,
  useTheme,
} from '@aws-amplify/ui-react';

function ReferenceImage({ faceLivenessAnalysis , eventId, token, assessmentUrl }) {
    const { tokens } = useTheme();

    const url = `https://dnche9w2ykvsb.cloudfront.net/api/event/${eventId}/livenessresults`;

    const saveLivenessResults = useCallback(async () => {
      console.log(`save ${eventId}`);
      const body = {
        sessionId: faceLivenessAnalysis.SessionId,
        token,
        data: faceLivenessAnalysis
      };
      await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': 'UWrQYxSWml2KDnh01WzRv5zq55jLsBPW85jgeZnV'
        },
        body: JSON.stringify(body),
      });
      launchTest();
    });

    useEffect(() => {
      saveLivenessResults();
  },[saveLivenessResults])

    const launchTest = () => {
      window.location = assessmentUrl;
    }

    return (
        <>
            <Alert
                variation="info"
                isDismissible={false}
                hasIcon={false}
                marginTop={tokens.space.large}
            >
                Event ID: {eventId}
            </Alert>
            <Alert
                variation="info"
                isDismissible={false}
                hasIcon={false}
            >
                Session ID: {faceLivenessAnalysis.SessionId}
            </Alert>
            <Alert
                variation="info"
                isDismissible={false}
                hasIcon={false}
            >
                Token: {token}
            </Alert>
            <Alert
                variation="info"
                isDismissible={false}
                hasIcon={false}
            >
                Confidence Score: {faceLivenessAnalysis.Confidence.toFixed(2)}%
            </Alert>
            <Alert
                variation="info"
                isDismissible={false}
                hasIcon={false}
            >
                Saving data... you will be redirected into the assessment shortly.
            </Alert>

            {/* <Button variation="primary" type="submit" marginTop={tokens.space.large} marginBottom={tokens.space.large} onClick={launchTest}>Continue</Button><br/><br/> */}
            {/* <Button variation="primary" type="submit" marginTop={tokens.space.large} marginBottom={tokens.space.large} onClick={tryAgain}>Try Again</Button> */}
        </>
    );
}

export default ReferenceImage;
